import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DeviceState, capitalize } from '@iotv/datamodel-core';
import { ComparisonType } from '@iotv/iotv-v3-types';
import { MenuItem, TextField, Toolbar } from '@mui/material';
import React, { useEffect, useState } from 'react';
export const TypeByState = (props) => {
    const { updateParams: setParamsInParent, lastQuery, lastQueryParamsRef, type, keyPress, index, attKey, children, selected } = props;
    const getDeviceKeys = () => {
        const keys = Object.keys(DeviceState).map((val) => capitalize(val.toLocaleLowerCase()));
        return keys.sort((a, b) => {
            return a.localeCompare(b, undefined, {
                numeric: true,
                sensitivity: 'base',
            });
        });
    };
    const [params, setParams] = useState(lastQuery);
    const [options, _] = useState(getDeviceKeys());
    const updateParamsWithSelected = (value) => {
        const inferred = DeviceState[value];
        if (inferred) {
            const selectedParam = { type, attKey, value: capitalize(inferred.toLocaleLowerCase()) };
            lastQueryParamsRef.current = selectedParam;
            setParams(selectedParam);
        }
    };
    useEffect(() => {
        if (options.length > 0) {
            updateParamsWithSelected(options[0].toLocaleUpperCase());
        }
    }, [options]);
    useEffect(() => {
        if (params && selected) {
            setParamsInParent([{ key: attKey, value: params.value.toLocaleUpperCase(), predicate: ComparisonType.EQUALS }], index);
        }
        else {
            setParamsInParent(undefined, index);
        }
    }, [params, selected]);
    const handleParamChange = (e) => {
        const value = e.target.value.toLocaleUpperCase();
        updateParamsWithSelected(value);
    };
    const displayDeviceTypes = (val) => {
        if (!val) {
            return '';
        }
        return `${capitalize(val.toLocaleLowerCase())}`;
    };
    return (_jsxs(Toolbar, { children: [children, _jsx("div", { style: { flexGrow: 1 }, children: _jsx(TextField, { select: true, size: "small", value: params?.value || '', onChange: handleParamChange, onKeyDown: keyPress, slotProps: {
                        select: {
                            renderValue: () => _jsx(_Fragment, { children: displayDeviceTypes(params?.value) }),
                        },
                    }, children: options.map((types) => (_jsx(MenuItem, { value: types, children: _jsx("b", { children: types }) }, types))) }) })] }));
};
